<template>
    <li>
        <div class="title"><span>セールススタイル</span></div>
        <div class="detail form_checkbox _w100">

        <template v-for="(sales_style, index) in $store.state.register.set.sales_style" v-bind:key="index">
            <input type="checkbox" name="edit-sales-style" class="" :id="'edit-sales-style1' + index" :value="sales_style" v-model="sales_styles">
            <label :for="'edit-sales-style1' + index">
                <div class="check-mark"><span></span></div>
                <span>{{ sales_style.name }}</span>
            </label>
        </template>

        </div>
    </li>
</template>

<script>
    export default {
        data() {
            return {
                sales_styles: [],
            }
        },
        computed: {
            // プレビューのために並び替え
            sortedItemsBySalesStyles(){
                return this.sales_styles.sort((a, b) => {
                    return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0;
                });;
            }
        },
        watch: {
            sales_styles: function () {
                this.$store.state.register.form.sales_style = this.sortedItemsBySalesStyles;
            }
        }
    }
</script>